export default {
    pleaseCompleteSecurityVerification: "ကျေးဇူးပြု၍ လုံခြုံရေးအတည်ပြုချက်ကို အပြီးသတ်ပါ။",
    slideToTheRightToValidation: "အတည်ပြုချက်ကို အပြီးသတ်ရန် ညာဘက်သို့ ပွတ်ဆွဲပါ။",
    verificationSuccessful: "အတည်ပြုခြင်း အောင်မြင်သည်။",
    verificationFailed: "အတည်ပြုခြင်း မအောင်မြင်ပါ။"
}